export const CHARACTER_AVATAR_FILES = Array.from({ length: 24 }, (_, idx) => {
  const n = String(idx + 1).padStart(2, "0");
  return `Avatar ${n}.png`;
});

export function toCharacterAvatarUrl(fileName) {
  if (!fileName) return null;
  return `/Avatars/${encodeURIComponent(String(fileName))}`;
}

export const CHARACTER_AVATARS = CHARACTER_AVATAR_FILES.map((file) => ({
  file,
  url: toCharacterAvatarUrl(file),
  label: file.replace(/\.png$/i, ""),
}));

export function isImageAvatarUrl(value) {
  if (typeof value !== "string") return false;
  const v = value.trim();
  if (!v) return false;
  return (
    v.startsWith("http://") ||
    v.startsWith("https://") ||
    v.startsWith("/") ||
    v.startsWith("data:") ||
    v.startsWith("blob:")
  );
}
